import React, { Component } from 'react';
import styled from 'styled-components';
import { LoadingSpinnerPage } from '../../../../components/atomic/Loaders/LoadingSpinner';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as apiServices from '../../../../services/apiServices';
import Body from './Body';
import { isSubmitted, setForm } from '../../../../modules/IndividualCoachForm';
import { setGlobalLoadingSpinner } from '../../../../modules/GlobalUI';
import { toast } from 'react-toastify';

const Container = styled.div`
`
class EditIndividualCoachForm extends Component {
  constructor(props) {
    super(props);
    this.submitQueue = [];
    this.state = {
      currentIndividualCoach: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    const { individualCoachData } = this.props;
    this.setState({
      currentIndividualCoach: individualCoachData,
      isLoading: false,
    });
  }

  setSubmitQueue = form => {
    const { history, isSubmitted } = this.props;
    const uid = form.id;
    const submitIndex = this.submitQueue.push(false) - 1;
    this.props.setGlobalLoadingSpinner(true, 'saving request...');
    apiServices.updateIndividualCoachForm(uid, form.formatforDB())
    .then(response => {
      this.submitQueue[submitIndex] = true;
      if(!this.submitQueue.includes(false)) {
        isSubmitted();
        this.submitQueue = [];
        history.goBack();
        toast.success(`Successfully updated request.`);
      }
    })
    .catch(e => {
      isSubmitted();
      this.submitQueue = [];
      console.log('component: ',this,e);
      toast.error(
        e.response.data.ValidationError ? e.response.data.ValidationError : e.message
      );
    })
  }

  submitForm = form => {
    const { setForm } = this.props;
    setForm(form);
  }

  render() {
    const { trainerState, programState } = this.props;
    const { currentIndividualCoach, isLoading } = this.state;
    return isLoading ? (
      <LoadingSpinnerPage/>
    ) : (
      <Container>
        <Body
          initialValues={currentIndividualCoach}
          affiliatedTrainersData={trainerState.affiliatedTrainersData}
          wellnessProgramsData={programState.wellnessPrograms}
          submit={this.submitForm}
        />
      </Container>
    )
  }
}

EditIndividualCoachForm.propTypes = {

};

EditIndividualCoachForm.defaultProps = {
  
};


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    isSubmitted: isSubmitted,
    setForm: setForm, 
    setGlobalLoadingSpinner: setGlobalLoadingSpinner
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditIndividualCoachForm);